export default __webpack_public_path__ + "static/media/Chilemat-trabaja-con-nosotros.1493a621.png";